import { useCallback, useContext, useEffect } from 'react';
import { useBackgroundNavigate, useSearchParams } from '@shared/hooks';
import { useBranchInspectionsTableColumns } from './use-branch-inspections-table-columns';
import { BranchInspectionsTableContext } from '../../context';

export const useBranchInspectionsTable = () => {
  const { handleFetch } = useContext(BranchInspectionsTableContext);
  const columns = useBranchInspectionsTableColumns();
  const navigate = useBackgroundNavigate();
  const { searchParams, remove } = useSearchParams<{ reFetchBranchInspectionsTable?: string }>();

  const getRowProps = useCallback(
    (id: any) => ({
      onDoubleClick: () => navigate(`/branch-inspections/${id}/details`, { withBackground: true }),
    }),
    [navigate],
  );

  useEffect(() => {
    (async () => {
      if (searchParams.reFetchBranchInspectionsTable) {
        remove.current('reFetchBranchInspectionsTable');
        await handleFetch();
      }
    })();
  }, [handleFetch, remove, searchParams.reFetchBranchInspectionsTable]);

  return { columns, getRowProps };
};
